import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { routes } from './app.router';

import { AppComponent } from './app.component';
import { SolutionsComponent } from './solutions/solutions.component';
import { HowWeDoItComponent } from './services/howwedoit/howwedoit.component';
import { CareersModule } from './careers/careers.module';
import { ActionableagiledeliveryComponent } from './actionableagiledelivery/actionableagiledelivery.component';
import { ManagedcloudservicesComponent } from './managedcloudservices/managedcloudservices.component';
import { CioadvisoryComponent } from './cioadvisory/cioadvisory.component';
import { ResearchadvisoryComponent } from './researchadvisory/researchadvisory.component';
import { SecadvisoryComponent } from './secadvisory/secadvisory.component';
import { ItondComponent } from './itond/itond.component';
import { PmondComponent } from './pmond/pmond.component';
import { FixedbidntComponent } from './fixedbidnt/fixedbidnt.component';
import { OnshoredComponent } from './onshored/onshored.component';
import { IntegrationComponent } from './integration/integration.component';
import { UinaComponent } from './uina/uina.component';
import { ServicesComponent } from './services/services.component';
import { PracticeComponent } from './practice/practice.component';
import { AboutModule } from './about/about.module';
import { HttpClientModule } from '@angular/common/http';
import { initializeKeycloak } from './utility/utility.init';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
// import { PartnersComponent } from './partners/partners.component';
// import { NewsComponent } from './news/news.component';

@NgModule({
  declarations: [
    AppComponent,
    SolutionsComponent,
    HowWeDoItComponent,
    ActionableagiledeliveryComponent,
    ManagedcloudservicesComponent,
    CioadvisoryComponent,
    ResearchadvisoryComponent,
    SecadvisoryComponent,
    ItondComponent,
    PmondComponent,
    FixedbidntComponent,
    OnshoredComponent,
    IntegrationComponent,
    UinaComponent,
    ServicesComponent,
    PracticeComponent
    // PartnersComponent,
    // NewsComponent,

  ],
  imports: [
    BrowserModule, HttpClientModule, FormsModule, routes,
    CareersModule, AboutModule, RouterModule, KeycloakAngularModule


  ],
  providers: [{
    provide: APP_INITIALIZER,
    useFactory: initializeKeycloak,
    multi: true,
    deps: [KeycloakService]
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
